"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var utils_1 = require("../utils");
/**
 * Creates an Observable that emits sequential numbers with by default
 * exponentially increasing interval of time.
 */
function intervalBackoff(config, scheduler) {
    if (scheduler === void 0) { scheduler = rxjs_1.asyncScheduler; }
    var _a = typeof config === 'number' ? { initialInterval: config } : config, initialInterval = _a.initialInterval, _b = _a.maxInterval, maxInterval = _b === void 0 ? Infinity : _b, _c = _a.backoffDelay, backoffDelay = _c === void 0 ? utils_1.exponentialBackoffDelay : _c;
    initialInterval = (initialInterval < 0) ? 0 : initialInterval;
    return rxjs_1.of(0, scheduler).pipe(
    // Expend starts with number 1 and then recursively
    // projects each value to new Observable and puts it back in.
    operators_1.expand(function (iteration) {
        return rxjs_1.timer(utils_1.getDelay(backoffDelay(iteration, initialInterval), maxInterval))
            // Once timer is complete, iteration is increased
            .pipe(operators_1.mapTo(iteration + 1));
    }));
}
exports.intervalBackoff = intervalBackoff;
